import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ask-wazzers',
  templateUrl: './ask-wazzers.component.html',
  styleUrls: ['./ask-wazzers.component.css']
})
export class AskWazzersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/ask-wazzers/ask-wazzers.component.ts